import { apiClient } from './client'

export interface CurrentEula {
  version: string
  sha256: string
  markdown: string
}

export async function fetchCurrentEula(): Promise<CurrentEula> {
  return apiClient('/eula/current')
}

export interface FlashAcceptanceResponse {
  ok: boolean
  accepted_at: string
}

export async function postFlashAcceptance(args: {
  device_mac: string
  eula_version: string
  eula_sha256: string
  prior_acceptance?: boolean
}): Promise<FlashAcceptanceResponse> {
  return apiClient('/flash-acceptance', {
    method: 'POST',
    body: JSON.stringify(args),
  })
}

export async function postEulaAcceptance(args: {
  eula_version: string
  eula_sha256: string
}): Promise<{ ok: boolean; accepted_at: string }> {
  return apiClient('/eula/accept', {
    method: 'POST',
    body: JSON.stringify(args),
  })
}
